import IconMinus from '@apollo/icons/default/IconMinus.svg';
import IconPlus from '@apollo/icons/default/IconPlus.svg';
import IconStatusDot from '@apollo/icons/default/IconStatusDot.svg';
import IconWarningSolid from '@apollo/icons/default/IconWarningSolid.svg';
import classnames from 'classnames';
import React, { CSSProperties } from 'react';

import { TypeOfChange } from '../getTypeOfChangeByChangeCodeAndTypeOfThing';

export const BaseChangeIcon = ({
  changeType,
  className,
  style,
}: {
  changeType: TypeOfChange | null;
  className?: string;
  style?: CSSProperties;
}) => {
  switch (changeType) {
    case 'ADDITION':
      return (
        <IconPlus
          style={style}
          className={classnames(className, 'text-icon-success')}
        />
      );
    case 'REMOVAL':
      return (
        <IconMinus
          style={style}
          className={classnames(className, 'text-icon-error')}
        />
      );
    case 'DEPRECATION':
      return (
        <IconWarningSolid
          style={style}
          className={classnames(className, 'text-icon-warning')}
        />
      );
    case 'THIS_CHANGED':
      return (
        <IconStatusDot
          className={classnames(className, 'text-icon-warning')}
          style={style}
        />
      );
    case 'SOMETHING_INSIDE_THIS_CHANGED':
    default:
      return (
        <div
          className={classnames(
            className,
            'inline-block rounded-full border-2 border-primary',
          )}
          style={style}
        />
      );
  }
};

const getSummaryIconStyles = (changeType: TypeOfChange | null) => {
  switch (changeType) {
    case 'ADDITION':
      return {
        width: 12,
        height: 12,
      };
    case 'REMOVAL':
      return {
        width: 12,
        height: 12,
      };
    case 'DEPRECATION':
      return {
        width: 12,
        height: 12,
      };
    case 'THIS_CHANGED':
      return {
        width: 12,
        height: 12,
      };
    case 'SOMETHING_INSIDE_THIS_CHANGED':
    default:
      return {
        width: 10,
        height: 10,
      };
  }
};

export const SummaryChangeIcon = ({
  changeType,
  className,
}: {
  changeType: TypeOfChange | null;
  className?: string;
}) => {
  return (
    <BaseChangeIcon
      changeType={changeType}
      className={className}
      style={getSummaryIconStyles(changeType)}
    />
  );
};

const getDetailedIconStyles = (changeType: TypeOfChange | null) => {
  switch (changeType) {
    case 'ADDITION':
      return {
        width: 16,
        height: 16,
      };
    case 'REMOVAL':
      return {
        width: 16,
        height: 16,
      };
    case 'DEPRECATION':
      return {
        width: 16,
        height: 16,
      };
    case 'THIS_CHANGED':
      return {
        width: 16,
        height: 16,
      };
    case 'SOMETHING_INSIDE_THIS_CHANGED':
    default:
      return {
        width: 10,
        height: 10,
      };
  }
};

export const DetailedChangeIcon = ({
  changeType,
  className,
}: {
  changeType: TypeOfChange | null;
  className?: string;
}) => {
  return (
    <BaseChangeIcon
      changeType={changeType}
      className={className}
      style={getDetailedIconStyles(changeType)}
    />
  );
};
